<script lang="ts" setup>
import Message from 'primevue/message'

defineProps<{
    error: unknown
}>()
</script>
<template>
    <div class="max-w-4xl mx-auto p-4">
        <Message severity="error">
            {{ error && typeof error === 'object' && 'message' in error ? error.message : error }}
        </Message>
    </div>
</template>
